{
  "name": "",
  "type": "object",
  "class": "g gtc-6 gtr-3",
  "definitions": [
    {
      "name": "customer",
      "type": "fieldOk",
      "class": "gr-1 gc-1-3 soft-overline text-accent flex flex-row items-center",
      "format": "{{number}} - {{name}}",
      "fieldOk": "ktostamm.kunde"
    },
    {
      "name": "object",
      "type": "fieldOk",
      "class": "gc-1-6 main-text mt-2",
      "format": "{{number}} - {{name}}",
      "fieldOk": "objekt"
    },
    {
      "name": "",
      "type": "text",
      "class": "gr-1 gc-4-6 soft-overline colored flex-nowrap flex flex-row justify-end items-center",
      "format": "{{from:TIME.DEFAULT}} - {{to:TIME.DEFAULT}}"
    },
    {
      "name": "description",
      "type": "text",
      "class": "gr-3 gc-1-6 flex flex-row mt-1 light-text"
    }
  ]
}
